/* esm.sh - @unhead/addons@2.1.12 */
import{InferSeoMetaPlugin as i}from"unhead/plugins";var t={htmlAttrs:{lang:"en"},meta:[{charset:"utf-8"},{name:"viewport",content:"width=device-width, initial-scale=1"}]};export{t as DefaultCriticalTags,i as InferSeoMetaPlugin};
//# sourceMappingURL=addons.mjs.map